<template>
  <modal-template size="large"
                  :title="$t('nominatives.datosDeLosAsistentes')"
                  @close="$root.$emit('closeSeatsioNominatives')">
    <div class="nominatives-modal container-nominatives container-seatsio">
      <form @submit.prevent="manageTickets">
        <div class="row">
          <div class="col-12 col-md-6">
            <p class="help-text">{{ $t('nominativesSeatsio.tusEntradasSonNominativasRecuerdaQue') }}</p>
            <div v-for="(category, index) in $store.state.seatsio.formattedSeats.categories"
                 :key="category.id">
              <div v-if="category.personal || category.personal_id">
                <p class="ticket-title">{{ category.category_label }}</p>
                <div v-for="(ticket, indexAux) in category.tickets"
                     :key="indexAux">
                  <p class="ticket-name">{{ ticket.labels.displayedLabel }}</p>
                  <input v-if="category.personal"
                         v-model="form.names[index][indexAux]"
                         :placeholder="$t('nominativesSeatsio.nombreYApellidos')"
                         :name="`assistant${indexAux}`"
                         type="text"
                         required
                         @input="nameTicket(form.names[index][indexAux], ticket, indexAux)">
                  <input v-if="category.personal_id"
                         v-model="form.idcards[index][indexAux]"
                         :placeholder="$t('nominativesSeatsio.DNI')"
                         :name="`DNI${indexAux}`"
                         type="text"
                         required
                         @input="idcardTicket(form.idcards[index][indexAux], ticket, indexAux)">
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div id="nominativesDetail"
                 class="selected">
              <p class="detail">{{ $t('nominatives.detalleDeCompra') }}</p>
              <div class="container-info">
                <div v-for="category in $store.state.seatsio.formattedSeats.categories"
                     :key="category.id">
                  <p class="tAl info">{{ category.quantity }}x {{ category.category_label }}</p>
                  <p class="tAr info">{{ $n(category.price * category.quantity, { key: 'currency', currency: $store.state.seatsio.config.currency }) }}</p>
                </div>
                <p class="tAl info">{{ $t('nominativesSeatsio.gastosDeGestion') }}</p>
                <p class="tAr info">{{ $n($store.state.seatsio.taxes, { key: 'currency', currency: $store.state.seatsio.config.currency }) }}</p>
                <p class="tAl total">{{ $t('nominativesSeatsio.total') }}</p>
                <p class="tAr total">{{ $n($store.state.seatsio.total, { key: 'currency', currency: $store.state.seatsio.config.currency }) }}</p>
              </div>
              <button :disabled="invalid"
                      :class="{'opacity': !invalid, 'transparent': invalid}"
                      class="btn purchase">{{ $t('nominativesSeatsio.comprar') }}</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </modal-template>
</template>

<script>
import { purchase } from '@/plugins/mixins/purchase.js'
import { userStatus } from '@/plugins/mixins/userStatus.js'
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'

export default {
  components: {
    ModalTemplate
  },
  mixins: [purchase, userStatus],
  data() {
    return {
      form: {
        names: [],
        idcards: []
      },
      header: undefined,
      nominativesDetail: undefined
    }
  },
  created() {
    this._initial()
    this.$store.state.seatsio.data.tickets.forEach((item, index) => {
      this.form.names[index] = []
      var array = Array.from(Array(item.quantity), (x, indexAux) => indexAux)
      if (item.personal) {
        array.forEach((itemAux, indexAux) => {
          this.form.names[index][indexAux] = ''
        })
      }
      this.form.idcards[index] = []
      if (item.personal_id) {
        array.forEach((itemAux, indexAux) => {
          this.form.idcards[index][indexAux] = ''
        })
      }
    })
  },
  mounted() {
    this.header = document.getElementById('header')
    this.nominativesDetail = document.getElementById('nominativesDetail')
    window.addEventListener('scroll', this.handleScrollNominativesDetail)
    this.handleScrollNominativesDetail()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScrollNominativesDetail)
    this.header = undefined
    this.nominativesDetail = undefined
  },
  methods: {
    handleScrollNominativesDetail() {
      var deviceType = this.$ua.deviceType()
      if (
        deviceType === 'pc' &&
        this.nominativesDetail &&
        window.scrollY >
          this.nominativesDetail.parentNode.offsetTop -
            this.header.offsetHeight -
            20
      ) {
        this.nominativesDetail.classList.add('isAffixed')
      } else if (this.nominativesDetail && this.nominativesDetail.classList) {
        this.nominativesDetail.classList.remove('isAffixed')
      }
    },
    manageTickets() {
      this.$store.dispatch('seatsio/cleanCategoryLabel')
      this.$store.dispatch(
        'purchase/setTickets',
        this.$store.state.seatsio.data
      )
      if (
        this.$store.state.initial.detail.user_id ||
        this.$store.state.user.detail.id
      ) {
        var userStatus = this.checkUserStatus()
        if (userStatus === 'name' || userStatus === 'profile') {
          this.$root.$emit('openBasicInfoPurchase')
        } else {
          this.$root.$emit('closeSeatsioNominatives')
          this.createPurchase('seatsio')
        }
      } else {
        this.$root.$emit('closeSeatsioNominatives')
        this.$root.$emit('openSignupPurchase')
      }
    },
    nameTicket(event, ticket, index) {
      this.$store.dispatch('seatsio/fill', {
        ticket: ticket,
        name: event,
        index: index
      })
    },
    idcardTicket(event, ticket, index) {
      this.$store.dispatch('seatsio/fill', {
        ticket: ticket,
        id_card: event,
        index: index
      })
    },
    async _initial() {
      await this.$store.dispatch('seatsio/formatSeats')
      await this.$store.dispatch('seatsio/setTaxesAndTotal')
    }
  }
}
</script>
